import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

import { PersonWithRestworldCupIllustration } from '@restworld/utils-common/illustrations/cv-parsing-loading-illustration-final';
import { Heading, Button } from '@restworld/ui-ds-base';

import { useWorkerApplicationCxt } from '../../worker-application-wizard.context';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IWizardExperienceInputConfirmModalProps {
  goToStep: (value: number) => void;
}

export const WizardExperienceInputConfirmModal: React.FunctionComponent<IWizardExperienceInputConfirmModalProps> = ({
  goToStep,
}) => {
  const { setOverlayModalContent } = useWorkerApplicationCxt();
  const router = useRouter();
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-6 items-center max-w-sm">
      <div className="flex flex-col gap-2">
        <Heading size={2} align="center">
          {t('onboarding-page:get_more_visibility_with_a_complete_profile')}
        </Heading>
        <Heading weight="normal" color="muted" align="center">
          {t('onboarding-page:log_in_whenever_you_want_using_your_email')}
        </Heading>
      </div>
      <PersonWithRestworldCupIllustration
        {...{
          height: 250,
          width: 200,
        }}
      />
      <div className="w-full bg-primary-50 flex flex-col gap-2 border-l-4 border-primary-800 p-2 rounded-lg">
        <Heading size={5} color="primary" className="leading-6">
          {t('onboarding-page:what_you_need_to_know')}
        </Heading>
        <Heading size={5} color="muted" weight="normal" className="leading-6">
          {t('onboarding-page:the_more_companies_you_attract')}
        </Heading>
      </div>
      <div className="flex flex-col gap-2 w-full">
        <Button
          fullwidth
          onClick={() => {
            setOverlayModalContent({ visible: false });
            goToStep(4);
          }}
        >
          {t('onboarding-page:continue_the_questionnaire')}
        </Button>
        <Button
          fullwidth
          variant="secondary-neutral"
          onClick={() => {
            router.push(`/candidature`);
          }}
        >
          {t('common:go_to_your_applications')}
        </Button>
      </div>
    </div>
  );
};

export default WizardExperienceInputConfirmModal;
